export const SITE_URL = 'https://kakobuyfinds.courses';